module.exports = __webpack_public_path__ + "img/sweet.22014eda.gif";